export default `
:host .wrapper {
  position: relative;
}
@keyframes textColorPulseAnimation {
  0% {
    color: rgba(0, 0, 0, 0.25);
  }
  50% {
    color: rgba(0, 0, 0, 0.5);
  }
  100% {
    color: rgba(0, 0, 0, 0.25);
  }
}
:host .wrapper .value {
  font-size: 2rem;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.25);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: textColorPulseAnimation 1000ms ease infinite;
  transition: color 1000ms ease;
}
@keyframes strokePulseAnimation {
  0% {
    stroke: rgba(0, 0, 0, 0.25);
  }
  50% {
    stroke: rgba(0, 0, 0, 0.5);
  }
  100% {
    stroke: rgba(0, 0, 0, 0.25);
  }
}
:host circle {
  transition: stroke-dashoffset 0.35s linear;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  position: relative;
  z-index: 999;
  animation: strokePulseAnimation 1000ms ease infinite;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9idWlsZGhvbWUvcmVwby9hcHAvY29tcG9uZW50cy9wcm9ncmVzcy1yaW5nIiwic291cmNlcyI6WyJwcm9ncmVzcy1yaW5nLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNFO0VBQ0U7O0FBR0Y7RUFDRTtJQUNFOztFQUVGO0lBQ0U7O0VBRUY7SUFDRTs7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7SUFDRTs7RUFFRjtJQUNFOztFQUVGO0lBQ0U7OztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICAud3JhcHBlciB7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB9XG5cbiAgQGtleWZyYW1lcyB0ZXh0Q29sb3JQdWxzZUFuaW1hdGlvbiB7XG4gICAgMCUge1xuICAgICAgY29sb3I6IHJnYmEoMCwgMCwgMCwgMC4yNSk7XG4gICAgfVxuICAgIDUwJSB7XG4gICAgICBjb2xvcjogcmdiYSgwLCAwLCAwLCAwLjUpO1xuICAgIH1cbiAgICAxMDAlIHtcbiAgICAgIGNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuMjUpO1xuICAgIH1cbiAgfVxuXG4gIC53cmFwcGVyIC52YWx1ZSB7XG4gICAgZm9udC1zaXplOiAycmVtO1xuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgIGNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuMjUpO1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICBsZWZ0OiAwO1xuICAgIHRvcDogMDtcbiAgICByaWdodDogMDtcbiAgICBib3R0b206IDA7XG4gICAgei1pbmRleDogMTAwMDtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgYW5pbWF0aW9uOiB0ZXh0Q29sb3JQdWxzZUFuaW1hdGlvbiAxMDAwbXMgZWFzZSBpbmZpbml0ZTtcbiAgICB0cmFuc2l0aW9uOiBjb2xvciAxMDAwbXMgZWFzZTtcbiAgfVxuXG4gIEBrZXlmcmFtZXMgc3Ryb2tlUHVsc2VBbmltYXRpb24ge1xuICAgIDAlIHtcbiAgICAgIHN0cm9rZTogcmdiYSgwLCAwLCAwLCAwLjI1KTtcbiAgICB9XG4gICAgNTAlIHtcbiAgICAgIHN0cm9rZTogcmdiYSgwLCAwLCAwLCAwLjUpO1xuICAgIH1cbiAgICAxMDAlIHtcbiAgICAgIHN0cm9rZTogcmdiYSgwLCAwLCAwLCAwLjI1KTtcbiAgICB9XG4gIH1cblxuICBjaXJjbGUge1xuICAgIHRyYW5zaXRpb246IHN0cm9rZS1kYXNob2Zmc2V0IDAuMzVzIGxpbmVhcjtcbiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgtOTBkZWcpO1xuICAgIHRyYW5zZm9ybS1vcmlnaW46IDUwJSA1MCU7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIHotaW5kZXg6IDk5OTtcbiAgICBhbmltYXRpb246IHN0cm9rZVB1bHNlQW5pbWF0aW9uIDEwMDBtcyBlYXNlIGluZmluaXRlO1xuICB9XG59XG4iXX0= */`;
